import { Dispatch, SetStateAction, useCallback } from 'react';

import { useSetAtom } from 'jotai';
import { WritableAtom } from 'jotai/vanilla';

import { baseSearchFormAtom } from 'data/Atom/Search';

export const useSetSearchAtom = <AtomValue>(
    atom: WritableAtom<AtomValue, [SetStateAction<AtomValue>], void>
): Dispatch<SetStateAction<AtomValue>> => {
    const dispatch = useSetAtom(atom);

    const setSearchForm = useSetAtom(baseSearchFormAtom);

    const updateRecent = useCallback(() => {
        setSearchForm((currentState) => ({
            ...currentState,
            recent: currentState.current,
        }));
    }, [setSearchForm]);

    return useCallback(
        (dispatchValue: SetStateAction<AtomValue>) => {
            // before update, push current search to recent
            dispatch(dispatchValue);
            updateRecent();
        },
        [dispatch, updateRecent]
    );
};
